var chunkToChildrenMap = {
	"3710": [
		1076,
		8067,
		9580,
		2731,
		4623,
		2350,
		7456,
		8322,
		3137,
		9064,
		9807
	],
	"5180": [
		1076,
		8067,
		9580,
		2731,
		4623,
		2350,
		7456,
		8322,
		3137,
		9064,
		9807
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));